import React from "react";
import PropTypes from "prop-types";
import { useLocation } from "react-router-dom";
import { MainContainer, Breadcrumbs, ContentContainer } from "./MainContent.styles";

const MainContent = ({ isSidebarExpanded, children }) => {
  const location = useLocation();
  const isHome = location.pathname === "/dashboard"; // Verifica se está na Home

  return (
    <MainContainer isSidebarExpanded={isSidebarExpanded}>
      {!isHome && (
        <Breadcrumbs>
          {/* Os breadcrumbs podem ser gerados dinamicamente */}
          <span>Home</span> / <span>Dashboard</span>
        </Breadcrumbs>
      )}
      <ContentContainer isHome={isHome}>{children}</ContentContainer>
    </MainContainer>
  );
};

MainContent.propTypes = {
  isSidebarExpanded: PropTypes.bool.isRequired,
  children: PropTypes.node.isRequired,
};

export default MainContent;
